import { render } from "./OverseasService.vue?vue&type=template&id=e9ce43a6&scoped=true"
import script from "./OverseasService.vue?vue&type=script&lang=js"
export * from "./OverseasService.vue?vue&type=script&lang=js"

import "./OverseasService.vue?vue&type=style&index=0&id=e9ce43a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9ce43a6"]])

export default __exports__